import React, { useEffect, useMemo, useState } from 'react';
import { FiFilter, FiRefreshCw } from 'react-icons/fi';

const ProductSalesReportFilters = ({ query, options = {}, loading, employee, onApply, meta = {} }) => {
  const [values, setValues] = useState(query);
  const [error, setError] = useState('');
  useEffect(() => { setValues(query); setError(''); }, [query]);
  const stores = options.stores || [];
  const businesses = useMemo(() => [...new Map(stores.filter((store) => store.business_id)
    .map((store) => [String(store.business_id), store])).values()], [stores]);
  const visibleStores = stores.filter((store) => !values.business_id || String(store.business_id) === String(values.business_id));
  const update = (key, value) => { setError(''); setValues((current) => ({ ...current, [key]: value })); };
  const apply = (next = values) => {
    if (!next.date_from || !next.date_to) return setError('Chọn đủ Từ ngày và Đến ngày.');
    if (next.date_from > next.date_to) return setError('Từ ngày không được lớn hơn Đến ngày.');
    setError('');
    onApply({ ...next, keyword: next.keyword.trim(), page: 1 });
  };
  return <section className='bc_rr_filter_panel bc_ps_filters' aria-label='Bộ lọc báo cáo'>
    <form onSubmit={(event) => { event.preventDefault(); apply(); }}>
      <div className='bc_ps_filter_fields'>
        <label><span>Từ ngày</span><input type='date' value={values.date_from} onChange={(event) => update('date_from', event.target.value)} /></label>
        <label><span>Đến ngày</span><input type='date' min={values.date_from} value={values.date_to} onChange={(event) => update('date_to', event.target.value)} /></label>
        <label><span>Chi nhánh</span><select value={values.business_id} onChange={(event) => {
          setError(''); setValues((current) => ({ ...current, business_id: event.target.value, store_id: '', salesperson: '' }));
        }}><option value=''>Tất cả chi nhánh được phân quyền</option>
          {businesses.map((store) => <option key={store.business_id} value={store.business_id}>{store.business_name || store.business_id}</option>)}
        </select></label>
        <label><span>Cửa hàng</span><select value={values.store_id} onChange={(event) => {
          setError(''); setValues((current) => ({ ...current, store_id: event.target.value, salesperson: '' }));
        }}><option value=''>Tất cả cửa hàng được phân quyền</option>
          {visibleStores.map((store) => <option key={store.store_id} value={store.store_id}>
            {[store.store_code, store.store_name].filter(Boolean).join(' - ')}
          </option>)}
        </select></label>
        {employee ? <label><span>Nhân viên</span><select value={values.salesperson} onChange={(event) => update('salesperson', event.target.value)}>
          <option value=''>Tất cả nhân viên được phân quyền</option>
          {(options.employees || []).map((person) => <option key={person.username} value={person.username}>
            {[person.username === '__UNASSIGNED__' ? '' : person.username, person.full_name].filter(Boolean).join(' - ')}
          </option>)}
        </select></label> : null}
        {meta.price_list_filter_available && (options.price_lists || []).length ? <label><span>Bảng giá</span>
          <select value={values.price_list_id} onChange={(event) => update('price_list_id', event.target.value)}>
            <option value=''>Tất cả bảng giá</option>
            {options.price_lists.map((price) => <option key={price.price_list_id} value={price.price_list_id}>{price.price_list_name}</option>)}
          </select>
        </label> : null}
        <label className='is-search'><span>Tìm hàng hóa</span>
          <input value={values.keyword} placeholder='Mã hoặc tên hàng hóa' onChange={(event) => update('keyword', event.target.value)} />
        </label>
        <div className='bc_ps_filter_actions'>
          <button type='button' disabled={loading} onClick={() => apply({ ...query, business_id: '', store_id: '', salesperson: '', keyword: '', price_list_id: '' })}><FiRefreshCw /> Xóa bộ lọc</button>
          <button type='submit' className='is-primary' disabled={loading}><FiFilter /> Áp dụng</button>
        </div>
      </div>
      {error ? <p className='bc_rr_field_error' role='alert'>{error}</p> : null}
    </form>
  </section>;
};

export default ProductSalesReportFilters;
